import React from 'react'
import { Divider as BaseDivider, Grid as BaseGrid, styled } from '@mui/material'
import {
  CheckCircle as BaseCheckCircleIcon,
  CloudDownloadOutlined as BaseCloudDownloadOutlinedIcon,
  FileCopy as BaseFileCopyIcon,
  Search as BaseSearchIcon
} from '@mui/icons-material'

const BaseContainer = styled(props => <BaseGrid container {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

const BaseItem = styled(props => <BaseGrid item {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const Clipboard = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 45px;
  min-height: 40px;
  padding: 4px 0 4px 16px;
  width: 100%;
`

export const ClipboardText = styled('div')`
  color: ${props => props.theme.palette.brand.white};
  font-family: Coda;
  font-size: 14px;
  overflow: hidden;
  pointer-events: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

export const ClipboardAction = styled('div')`
  display: flex;
  justify-content: center;
  pointer-events: none;
  user-select: none;
`

export const ClipboardIcon = styled(BaseFileCopyIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    font-size: 18px;
    pointer-events: none;
    user-select: none;
  }
`

export const ClipboardIconCopied = styled(BaseCheckCircleIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.green[75]};
    font-size: 18px;
    pointer-events: none;
    user-select: none;
  }
`

export const Container = styled(BaseContainer)``

export const Divider = styled(({ margin, ...props }) => <BaseDivider {...props} />)`
  &.MuiDivider-root {
    margin: ${props => props.margin};
  }
`

export const DownloadIcon = styled(BaseCloudDownloadOutlinedIcon)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.blue[35]};
    font-size: 56px;
    padding-inline: 8px;
  }
`

export const Item = styled(BaseItem)``

export const List = styled('ul')`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding-inline: 32px;
`

export const ListItem = styled('li')`
  padding-inline: 16px;
`

export const Root = styled(BaseContainer)``

export const Strong = styled('span')`
  font-weight: bold;
`

export const Wrapper = styled('div')`
  display: grid;
  gap: 8px;
  grid-template-columns: 72px 1fr 210px;

  .MuiButtonBase-root {
    align-self: flex-end;
  }

  ${props => props.theme.breakpoints.down('md')} {
    grid-template-columns: 72px 1fr;
    grid-template-rows: 1fr 1fr;

    .MuiButtonBase-root {
      align-self: auto;
      grid-column: 2;
      grid-row: 2;
    }
  }
`
